<template lang="pug">
  #change-password-modal.modal-card(style='width: auto')
    header.modal-card-head
      p.modal-card-title Change Your Password
    section.modal-card-body
      div.notification.is-danger(v-if="hasError") {{ errorMessage }}

      BField(
        label="Old Password"
        :type="{ 'is-danger': errors.has('old password') }"
        :message="errors.first('old password')"
      )
        BInput(
          password-reveal
          name="old password"
          type='password',
          v-model='oldPassword',
          placeholder='Old password'
          v-validate="'required'"
        )
      BField(
        label="New Password"
        :type="{ 'is-danger': errors.has('new password') }"
        :message="errors.first('new password')"
      )
        BInput(
          password-reveal
          name="new password"
          type='password',
          v-model='newPassword',
          placeholder='New password'
          v-validate="'required|min:8'"
          ref="new password"
        )
      PasswordComplexityCheck(:password="newPassword")
      br
      BField(
        label="Confirm New Password"
        :type="{ 'is-danger': errors.has('confirm') }"
        :message="errors.first('confirm')"
      )
        BInput(
          password-reveal
          name="confirm"
          type='password',
          v-model='passwordConfirm',
          placeholder='Confirm new password'
          v-validate="'required|confirmed:new password'"
          data-vv-as="new password"
        )
    footer.modal-card-foot
      WtButton.button.is-danger(@click.native="closePasswordModal") Cancel
      WtButton.button.is-primary(@click.native="resetPassword") Save
</template>

<script>
import { mapActions } from "vuex";
import WtButton from "@@/WtButton/WtButton";
import PasswordComplexityCheck from "@@/PasswordComplexityCheck.vue";

export default {
  name: "ChangePasswordModal",

  components: { WtButton, PasswordComplexityCheck },

  data() {
    return {
      oldPassword: "",
      newPassword: "",
      passwordConfirm: "",
      hasError: false,
      errorMessage: ""
    };
  },

  methods: {
    ...mapActions("members", ["changePassword"]),
    ...mapActions(["snackBar"]),

    closePasswordModal() {
      this.$emit("passwordModalOpen", false);
    },

    resetPassword() {
      this.hasError = false;
      this.$validator.validateAll().then(async result => {
        if (result) {
          const formData = new FormData();
          await formData.append("oldPassword", this.oldPassword);
          await formData.append("newPassword", this.newPassword);
          await formData.append(
            "newPassword_confirmation",
            this.passwordConfirm
          );

          const payload = {
            memberId: this.$auth.user().id,
            formData
          };

          return this.changePassword(payload)
            .then(response => {
              if (response && response.data.success) {
                this.snackBar({ message: "Your password has been changed." });
                this.closePasswordModal();
              }
              if (response.data.error) {
                this.hasError = true;
                this.errorMessage = response.data.error.message;
              }
            })
            .catch(response => {
              if (!response.data.error) {
                this.snackBar({
                  duration: 10000,
                  type: "is-danger",
                  message:
                    "There was an error changing your password. Please try again. Or reach out to wellness@be-engaged.co."
                });
                this.closePasswordModal();
              }
            });
        }
      });
    }
  }
};
</script>
